import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';
import { TransferOrderStatus } from '../../components/transfer-order-status/transfer-order-status';
import { transferOrderGridProperties } from '../../data/transfer-order-properties';
import type { GridColumn } from './types';

const name = <FormattedMessage {...messages.statusColumnHeader} />;

export const transferOrderStatusColumn: GridColumn = {
  name,
  render: (data) => {
    const { status } = data;
    return <TransferOrderStatus status={status as string} />;
  },
  id: transferOrderGridProperties.status,
};
